
const generateData =()=> {
    const data = [];
    for (let i = 0; i <= 300; i++) {
      data.push(0);
    }
    return data;
  };
export const state = {
    nickname: '',
    avatar: '',
    loadimg1attr:generateData(),
    suodingtipcss: 'display: none',
    sharetipcontainercss: 0,
    morentanchuangcss: 0,
    chuangtitle: '',
    fn: '',
    jindu: '',
    starcss: 'display: none',
    isalljiazai: 'loadimg',
    yujiazaicss: 1,
    isplaybgmusic: 0,
    pruanbgcss: '',
    pruanjianpancss: '',
    morentanchuangshow: 0,
    isshowswper1: 0,
    isshowswper2: 0,
    isshowswper3: 0,
    isshowswper4: 0,
    isActive: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    isActive1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    isActive2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    isActive3: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    isActive4: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    isshowswipermoban: 1,
    isshowp2: 0,
    isshowp3: 0,
    isshowp4: 0,
    isshowp5: 0,
    isshowp6: 0,
    isshowp7: 0,
    isshowp8: 0,
    isshowp9: 0,
    isshowjiazai: 0,
    red: 0,
    sharewz: '分享朋友圈邀请好友助力',
    gettip: '',
   
};
export const getters = {

}
export const mutations = {
    closeallpage(state){
        state.isshowp2 = 0;
        state.isshowp3 = 0;
        state.isshowp4 = 0;
        state.isshowp5 = 0;
        state.isshowp6 = 0;
        state.isshowp7 = 0;
        state.isshowp8 = 0;
        state.isshowp9 = 0;
    },
    isshowswipermobanset(state, isshowswipermoban) {
        state.isshowswipermoban = isshowswipermoban;
    },
    gettipset(state, gettip) {
        state.gettip = gettip;
    },
    sharewzset(state, sharewz) {
        state.sharewz = sharewz;
    },
    nicknameset(state, nickname) {
        state.nickname = nickname;
    },
    redset(state, red) {
        state.red = red;
    },
    isshowjiazaiset(state, isshowjiazai) {
        state.isshowjiazai = isshowjiazai;
    },
    avatarset(state, avatar) {
        state.avatar = avatar;
    },
    loadimg1attrset(state, index) {
        state.loadimg1attr=generateData();
        state.loadimg1attr[index] = 1;
    },

    isshowp2set(state, isshowpage) {
        state.isshowp2 = isshowpage;
    },

 
    isshowp3set(state, isshowpage) {
        state.isshowp3 = isshowpage;
    },
    isshowp4set(state, isshowpage) {
        state.isshowp4 = isshowpage;
    },
    isshowp5set(state, isshowpage) {
        state.isshowp5 = isshowpage;
    },
    isshowp6set(state, isshowpage) {
        state.isshowp6 = isshowpage;
    },
    isshowp7set(state, isshowpage) {
        state.isshowp7 = isshowpage;
    },
    isshowp8set(state, isshowpage) {
        state.isshowp8 = isshowpage;
    },
    isshowp9set(state, isshowpage) {
        state.isshowp9 = isshowpage;
    },
    suodingtipset(state, suodingtipcss) {
        state.suodingtipcss = suodingtipcss;
    },
    isActiveset(state, slideIndex) {
        var sss = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        sss[slideIndex] = 1;
        state.isActive = sss
    },
    isActive1set(state, slideIndex) {
        var sss = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        sss[slideIndex] = 1;
        state.isActive1 = sss
    },
    isActive2set(state, slideIndex) {
        var sss = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        sss[slideIndex] = 1;
        state.isActive2 = sss
    },
    isActive3set(state, slideIndex) {
        var sss = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        sss[slideIndex] = 1;
        state.isActive3 = sss
    },
    isActive4set(state, slideIndex) {
  
        var sss = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        sss[slideIndex] = 1;
        state.isActive4 = sss
    },
    sharetipcontainerset(state, sharetipcontainercss) {
        state.sharetipcontainercss = sharetipcontainercss
    },
    pruanjianpanset(state, pruanjianpancss) {
        state.pruanjianpancss = pruanjianpancss
    },
    pruanbgset(state, pruanbgcss) {
        state.pruanbgcss = pruanbgcss
    },
    morentanchuangset(state, [morentanchuangcss, title, fn]) {

        state.morentanchuangcss = morentanchuangcss
        state.chuangtitle = title
        state.fn = fn
    },
    morentanchuangshowset(state) {
        state.morentanchuangshow = 1
    },
    isshowswper1set(state, isshowswper1css) {
        state.isshowswper1 = isshowswper1css
    },
    isshowswper2set(state, isshowswper2css) {
        state.isshowswper2 = isshowswper2css
    },
    isshowswper3set(state, isshowswper3css) {
        state.isshowswper3 = isshowswper3css
    },
    isshowswper4set(state, isshowswper4css) {
        state.isshowswper4 = isshowswper4css
    },
    jinduset(state, jindu) {
        state.jindu = jindu;
    },
    starset(state, starcss) {
        state.starcss = starcss
    },
    yujiazaiset(state, yujiazaicss) {
        state.yujiazaicss = yujiazaicss
    },
    alljiazaiset1(state) {
        state.isalljiazai = 'loadimg'
    },
    alljiazaiset(state) {
        state.isalljiazai = 'src'
    },
    isplaybgmusicset(state, isplaybgmusic) {
        state.isplaybgmusic = isplaybgmusic
    },
}




// WEBPACK FOOTER //
// ./src/store/index1.js